"use client"

import { ShipWheel } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShipWheelIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShipWheelIcon = component(Icon)({ as: ShipWheel })
